import { type ComponentPropsWithoutRef } from 'react';
import { Dialog } from '@optiaxiom/react';

export type SpotlightRootProps = ComponentPropsWithoutRef<typeof Dialog>;

/**
 * Root of the vendored Spotlight — a controlled Axiom `Dialog`. Owns the
 * open/close state (`open` / `onOpenChange`). Pair with `SpotlightContent`
 * and `SpotlightInput`.
 */
export function SpotlightRoot(props: SpotlightRootProps) {
  return <Dialog {...props} />;
}

SpotlightRoot.displayName = 'SpotlightRoot';
